import { Backdrop, CircularProgress, Typography, Tabs, Tab, Box } from "@mui/material";
import { useEffect, useState } from "react";
import usePageTitle from "../../../Common/hooks/usePageTitle";
import TopBar from "../../../Layout/components/TopBar/TopBar";
import { useReports } from "../hooks/useReports";
import CostCenterValidationGrid from "../components/CostCenterValidationGrid";
import styles from "./AdminReportsView.module.scss";

interface TabPanelProps {
    readonly children?: React.ReactNode;
    readonly index: number;
    readonly value: number;
}

function CustomTabPanel(props: Readonly<TabPanelProps>) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`reports-tabpanel-${index}`}
            aria-labelledby={`reports-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

const AdminReportsView = (): JSX.Element => {
    const { reports, isLoading, fetchReports } = useReports();
    const [tabValue, setTabValue] = useState(0);
    usePageTitle("Admin | Reports");

    useEffect(() => {
        fetchReports();
    }, []);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return (
        <div id="adminreports" data-testid="adminreports" style={{ height: "100%" }}>
            <TopBar>
                <div className={styles.details__topBarContainer}>
                    <Typography variant="h4">Reports</Typography>
                </div>
            </TopBar>

            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Box sx={{ borderBottom: 1, borderColor: "divider", pl: "80px", pt: "24px" }}>
                <Tabs value={tabValue} onChange={handleTabChange} aria-label="reports tabs">
                    <Tab label="Cost Center Validation" id="reports-tab-0" />
                </Tabs>
            </Box>

            <CustomTabPanel value={tabValue} index={0}>
                <CostCenterValidationGrid reports={reports} />
            </CustomTabPanel>
        </div>
    );
};

export default AdminReportsView;
